export const LANG_IT_NAME = 'it';

export const LANG_IT_TRANS = {
    login: 'Accedi',
    selectLanguage: 'Seleziona lingua',
    profileChoose: 'Scegli la tua specialità e la lingua',
    speciality: 'Specialità',
    language: 'Lingua',
    saveAndContinue: 'Salva e continua',
    capitalChoose: 'Puoi scegliere un capitolo qui.',
    questions: 'DOMANDE',
    question: 'Domanda',
    dashboard: 'PANORAMICA',
    logout: 'Esci',

    //Question buttons
    previous: 'Precedente',
    next: 'Successivo',
    finish: 'Termina',
    checkAnswer: 'Verifica risposta',
    source: 'Fonte:',

    //Dashboard
    trackStatistics: 'Monitora le tue statistiche',
    correct: 'Corretto',
    wrong: 'Errato',
    unanswered: 'Senza risposta',
    percentCorrect: '% corrette',
    capital: 'Capitolo',
    total: 'Totale',
    practiceFailed: 'Esercitati sulle domande errate',
    practiceUnanswered: 'Esercitati sulle domande senza risposta',
    resetQuestions: 'Reimposta tutte le domande',
    resetQuestionNotification: 'Le tue risposte sono state reimpostate.',
    resetNoQuestionNotification: 'Non hai domande da reimpostare',
    yes: 'Sì',
    no: 'No',
    resetConfirmMessage: 'Sei sicuro di voler eliminare tutte le tue risposte?',
    wrongQuestionNotification: 'Non hai domande errate.',
    unansweredQuestionNotification: 'Non hai domande senza risposta.',
    anyQuestionNotification: 'Non hai domande.',

    //Login
    emailValidError: 'Inserisci un indirizzo e-mail valido',
    emailRequiredError: 'Inserisci il tuo indirizzo e-mail',
    passwordInputError: 'Inserisci la tua password',
    password: 'Password',
    email: 'E-mail',
    forgotPassword: 'Password dimenticata',

    //Forgot Password component
    passwordRecovery: 'Recupero password',
    enterEmail: 'Inserisci la tua e-mail e ti invieremo una nuova password',
    send: 'Invia',
    forgotEmail: 'E-mail dimenticata',
    checkEmail: 'Controlla la tua e-mail',
    checkEmailMessage: 'Ti abbiamo inviato un\'e-mail, controllala per reimpostare la password.',
    returnLogin: 'Torna al login',
    contactMessage1: 'Puoi contattarci all\'indirizzo ',
    contactEmail: 'support@medexam.app',
    contactMessage2: ' per recuperare l\'e-mail registrata.',
    noSendEmail: 'Impossibile inviare l\'e-mail. Riprova più tardi.',
    setNewPassword: 'Imposta una nuova password',
    setNewPasswordHint: 'Inserisci una nuova password per il tuo account.',
    newPassword: 'Nuova password',
    confirmPassword: 'Conferma password',
    passwordMismatch: 'Le password non coincidono',
    savePassword: 'Salva password',
    resetPasswordSuccess: 'La password è stata aggiornata. Ora puoi accedere.',
    resetPasswordError: 'Questo link non è valido o è scaduto. Richiedine uno nuovo.',

    correctPercentage: 'Percentuale di risposte corrette',

    // Guest demo
    demoTitle: 'Prova 10 domande gratuite',
    demoIntro: 'Rispondi a 10 domande di esercitazione senza registrarti e senza pagare. L’intera banca domande resta disponibile dopo l’acquisto.',
    demoStart: 'Avvia demo',
    demoContinue: 'Continua la demo',
    demoFreeQuestions: 'Prova 10 domande gratuite',
    demoLoginLink: 'Accedi',
    demoBadge: 'Demo gratuita',
    demoOf: 'di',
    demoFallbackNotice: 'Domande di esempio: l’API ospite non è ancora disponibile.',
    demoUnavailable: 'La demo non è al momento disponibile. Riprova più tardi.',
    demoFinishedTitle: 'Demo terminata',
    demoFinishedLead: 'Hai usato le 10 domande gratuite. Sblocca l’intera banca domande per continuare a esercitarti.',
    demoScoreCaption: 'risposte corrette',
    demoPurchaseCta: 'Acquista le domande d’esame',
    demoAlreadyCompleted: 'Hai già completato le 10 domande gratuite in questo browser.',
    demoSeeResults: 'Vedi i risultati',

    // Mock exam
    mockTest: 'SIMULAZIONE D\'ESAME',
    mockIntro: 'Simulazione a tempo dell’EDAIC Part 1: Paper A (Basic Sciences) e Paper B (Clinical Practice).',
    mockRuleQuestions: '60 domande, ciascuna con fino a 5 affermazioni vero/falso',
    mockRuleScoring: '1 punto per ogni affermazione giudicata correttamente, nessun punteggio negativo; una risposta vuota vale 0',
    mockRuleFeedback: 'Nessun riscontro fino alla fine dell’esame',
    mockPaperA: 'Paper A',
    mockPaperATitle: 'Scienze di base',
    mockPaperATopic1: 'Fisiologia',
    mockPaperATopic2: 'Farmacologia',
    mockPaperATopic3: 'Fisica, misurazioni cliniche e statistica',
    mockPaperB: 'Paper B',
    mockPaperBTitle: 'Pratica clinica',
    mockPaperBTopic1: 'Anestesia generale',
    mockPaperBTopic2: 'Anestesia locoregionale',
    mockPaperBTopic3: 'Anestesia specialistica, dolore compreso',
    mockPaperBTopic4: 'Medicina intensiva',
    mockPaperBTopic5: 'Medicina interna',
    mockPaperBTopic6: 'Medicina d’urgenza',
    mockDuration: 'Durata',
    mockDurationPaper: '120 min (prova cartacea)',
    mockDurationComputer: '90 min (prova al computer)',
    mockStart: 'Inizia l’esame',
    mockShortfallTitle: 'Domande insufficienti',
    mockShortfallLine: '{paper} · {area}: {available} su {requested} disponibili',
    mockResumeTitle: 'Esame non concluso',
    mockResumeBody: 'Hai un esame in corso che non è ancora scaduto.',
    mockResume: 'Riprendi l’esame',
    mockHistory: 'Esami precedenti',
    mockHistoryEmpty: 'Nessun esame concluso finora.',
    mockSubmitted: 'Consegnato',
    mockScore: 'Punteggio',
    mockResultLink: 'Risultato',
    mockRemaining: 'Tempo rimanente',
    mockFlag: 'Segna',
    mockFlagged: 'Segnata',
    mockSubmit: 'Concludi l’esame',
    mockSubmitShort: 'Consegna',
    mockSubmitConfirm: 'Vuoi davvero consegnare l’esame?',
    mockPartial: 'Risposta parziale',
    mockAnswered: 'Risposta data',
    mockNavigator: 'Mappa delle domande',
    mockNavigatorSummary: 'Mappa delle domande ({answered}/{total} risposte, {flagged} segnate)',
    mockResultTitle: 'Risultato',
    mockPassed: 'Superato',
    mockFailed: 'Non superato',
    mockPassGuide: 'Valore indicativo {threshold} %; la soglia ufficiale ESAIC varia ogni anno',
    mockAreas: 'Punti per area',
    mockArea: 'Area',
    mockReview: 'Revisione',
    mockYourAnswer: 'La tua risposta',
    mockCorrectIs: 'Risposta corretta',
    mockBlankAnswer: 'Vuota',
    mockHint: 'Suggerimento',
    mockPoint: 'punto',
    mockPoints: 'punti',
    mockBack: 'Torna alla simulazione',
    mockTrue: 'Vero',
    mockFalse: 'Falso',
    mockLoadError: 'Impossibile caricare l’esame. Riprova.',
    mockSubscriptionTitle: 'Abbonamento necessario',
    mockSubscriptionBody: 'Per la simulazione d’esame è necessario un abbonamento attivo.',
    mockSubscriptionKept: 'Le risposte già date restano salvate.',
    mockSubscribe: 'Abbonati',
    mockSubmitError: 'Impossibile consegnare l’esame. Riprova.',
    mockTimeUp: 'Il tempo è scaduto. Le risposte vengono consegnate.',
    mockSelectPaper: 'Seleziona un paper.',
    mockArea_statistics: 'Statistica',
    mockArea_physiology: 'Fisiologia',
    mockArea_pharmacology: 'Farmacologia',
    mockArea_physics: 'Fisica e misurazioni cliniche',
    mockArea_general_anaesthesia: 'Anestesia generale',
    mockArea_regional_anaesthesia: 'Anestesia locoregionale',
    mockArea_special_anaesthesia: 'Anestesia specialistica',
    mockArea_intensive_care: 'Medicina intensiva',
    mockArea_internal_medicine: 'Medicina interna',
    mockArea_emergency_medicine: 'Medicina d’urgenza',

    // Accessibility: answer states, result announcement, list status, dashboard sorting
    answerSelected: 'Selezionata',
    answerCorrectSelected: 'Corretta – l’hai selezionata',
    answerCorrectMissed: 'Risposta corretta – non selezionata',
    answerWrongSelected: 'Errata – l’hai selezionata',
    answerWrongNotSelected: 'Errata – giustamente non selezionata',
    resultCorrect: 'Corretto.',
    resultWrong: 'Non corretto.',
    resultDetail: '{correct} affermazioni su {total} valutate correttamente.',
    statusCorrect: 'Risposta corretta',
    statusWrong: 'Risposta errata',
    statusUnanswered: 'Non ancora risposto',
    weakestTopic: 'Argomento più debole',
    sortBy: 'Ordina per',
    sortedAscending: 'ordinato in modo crescente',
    sortChapterOrder: 'Ordine dei capitoli',
    sortWeakestFirst: 'Più deboli per primi (% corrette, crescente)',
    sortOriginal: 'Ordine predefinito',
    answerLegendTitle: 'Come leggo la visualizzazione?',
    answerLegendCorrect: 'L’affermazione è corretta e fa parte della soluzione.',
    answerLegendWrong: 'L’affermazione è errata e non fa parte della soluzione.',
    answerLegendSelection: 'Il testo accanto al simbolo indica se hai selezionato l’affermazione. I colori sono solo un aiuto in più.',
};
